<script lang="ts" setup>
import { computed } from 'vue'

import { AuthorHeader, AuthorHeaderContent, Heading, AuthorHeaderJobtitle, SocialStrip, Button, EmailIcon, XIcon, FacebookIcon, InstagramIcon, LinkedinIcon, YoutubeIcon, BlockContainer } from '@toni/brand-ui'

import { useMediaQuery } from '../../utils/use-media-query'
import { AuthorAvatar } from '../ui/article-meta'

function createHref (type: string, url: string) {
  if (type === 'email') {
    return 'mailto:' + url
  } else {
    return url
  }
}

function setTarget (type: string) {
  if (type === 'email') {
    return '_self'
  } else {
    return '_blank'
  }
}

const isDesktop = useMediaQuery('md')

const socialIconComponents: Record<string, typeof EmailIcon | typeof XIcon | typeof FacebookIcon | typeof InstagramIcon | typeof LinkedinIcon> = {
  email: EmailIcon,
  twitter: XIcon,
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  linkedin: LinkedinIcon,
  youtube: YoutubeIcon
}

defineProps<{
  headline: string,
  jobTitle: string,
  image: object,
  socialStrip: {
    socialType: string
    url: string
  }[]
}>()

function getSocialIconComponent (socialType: string) {
  return socialIconComponents[socialType] || null
}

const buttonSize = computed(() => {
  return isDesktop.value ? 'sm' : 'lg'
})

const iconSize = computed(() => {
  return isDesktop.value ? 16 : 20
})
</script>

<template>
  <BlockContainer>
    <AuthorHeader>
      <AuthorAvatar :image="image"
                    size="4xl"
                    variant="image"
                    :name="headline" />
      <AuthorHeaderContent>
        <Heading variant="h1"
                 class="mb-1">
          {{ headline }}
        </Heading>
        <AuthorHeaderJobtitle>
          {{ jobTitle }}
        </AuthorHeaderJobtitle>
        <SocialStrip :social-strip="socialStrip">
          <Button v-for="item, id in socialStrip"
                  :key="`social-icon-${id}`"
                  :href="createHref(item.socialType, item.url)"
                  :target="setTarget(item.socialType)"
                  variant="secondary"
                  :size="buttonSize"
                  type="icon-only">
            <component :is="getSocialIconComponent(item.socialType)"
                       :size="iconSize" />
          </Button>
        </SocialStrip>
      </AuthorHeaderContent>
    </AuthorHeader>
  </BlockContainer>
</template>
